import { render, staticRenderFns } from "./categoryHighlight.vue?vue&type=template&id=214ba708&"
import script from "./categoryHighlight.vue?vue&type=script&lang=js&"
export * from "./categoryHighlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports